module.exports = __webpack_public_path__ + "media/2.a541a1a7.mp3";